import { app } from '../../../app';

app.component('subscriptionSuccess', {
    bindings: {errorMessage: '<'},
    templateUrl: require('./subscription-success.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/subscription-success/subscription-success.component.js